import React, { useEffect } from 'react';
import OurReviews from './OurReviews';
import ContentPageLayout from './ContentPageLayout';

const OurReviewsPage: React.FC = () => {
    useEffect(() => {
        document.title = 'Our Reviews - DeliFeed';
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute('content', 'Read what our customers say about DeliFeed - authentic Mediterranean food delivery in Cambourne. See reviews and testimonials from our happy customers.');
        }
    }, []);

    return (
        <ContentPageLayout title="Our Reviews">
            <OurReviews />
        </ContentPageLayout>
    );
};

export default OurReviewsPage;
